var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.canViewDefinition
        ? _c("div", { staticClass: "table-browser-word-break" }, [
            _vm._v("\n        " + _vm._s(_vm.item.shortDefinition) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      [
        _vm.canViewReference || _vm.canViewComment ? [_c("hr")] : _vm._e(),
        _vm._v(" "),
        _vm.canViewReference
          ? _c("div", [
              _c("small", [
                _vm._v("References:\n                "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.item.references) },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canViewComment
          ? _c("div", [
              _c("small", [
                _vm._v("Comments:\n                "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.item.comments) },
                }),
              ]),
            ])
          : _vm._e(),
      ],
      _vm._v(" "),
      _vm.isAllMetadata && _vm.canViewChildren
        ? [
            _vm.item[_vm.caseFoldMetadataType]
              ? [
                  _vm.hasChildren ? [_c("hr")] : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.metadataTypeChildren, function (child, index) {
                    return _c("div", { key: index }, [
                      _vm.item[_vm.caseFoldMetadataType][child]
                        ? _c("div", [
                            _c("small", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("removeLastWord")(
                                      _vm.item[_vm.caseFoldMetadataType][child]
                                        .__typename
                                    )
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm.item[_vm.caseFoldMetadataType][child]
                                      .name
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMetadataTypeThatHasChildren && _vm.canViewChildren
        ? [
            _vm.hasChildren ? [_c("hr")] : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.metadataTypeChildren, function (child, index) {
              return _c("div", { key: index }, [
                _vm.item[child]
                  ? _c("div", [
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm._f("removeLastWord")(_vm.item[child].__typename)
                          ) +
                            ": " +
                            _vm._s(_vm.item[child].name)
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }